import type { HelpFile } from '../../types/help'
import { AuthLoopPageTestIds } from '../../../testids/AuthLoopPageTestIds'

export const authLoopPageHelp: HelpFile = {
  docPage: '/docs/troubleshooting/auth-loop',
  texts: {
    [AuthLoopPageTestIds.authLoopTitle]: 'Sie scheinen in einer Login-Schleife festzustecken. Über die Aktionen unten lässt sich der Zustand bereinigen.',
    [AuthLoopPageTestIds.authLoopTryAgain]: 'Den Login-Vorgang erneut versuchen. Cookies bleiben erhalten, sodass eine bestehende Sitzung fortgesetzt werden kann.',
    [AuthLoopPageTestIds.authLoopLogoutFully]: 'Vollständig abmelden und Sitzung löschen, dann neu anmelden.',
  },
}
